import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { collapse, expand } from '../../../utils/transition';
import AccordionHeader from './AccordionHeader';

class Accordion extends Component {
  constructor(props) {
    super(props);
    const { expanded, defaultExpanded } = this.props;
    this.toggle = this.toggle.bind(this);
    this.state = {
      expanded: !!(expanded || defaultExpanded)
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.expanded !== undefined && props.expanded !== state.expanded) {
      return {
        expanded: props.expanded
      };
    }
    return null;
  }

  toggle() {
    const { expanded } = this.state;
    const { id, onChange } = this.props;

    this.setState({ expanded: !expanded });
    if (expanded) {
      collapse(this, 'accordion__content-wrapper--expanded');
    } else {
      expand(this, 'accordion__content-wrapper--expanded');
    }
    if (onChange) {
      onChange(id, !expanded);
    }
  }

  render() {
    const { header = AccordionHeader, headerText, children, className } = this.props;
    const { expanded } = this.state;

    const accordionClass = classNames('accordion', className);
    const wrapperClass = classNames('accordion__content-wrapper', {
      'accordion__content-wrapper--expanded': expanded
    });

    return (
      <div className={accordionClass}>
        {header({
          onClick: this.toggle,
          expanded,
          headerText
        })}
        <div
          className={wrapperClass}
          ref={(ref) => {
            this.contentNode = ref;
          }}
        >
          {children}
        </div>
      </div>
    );
  }
}

Accordion.propTypes = {
  header: PropTypes.func,
  headerText: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  expanded: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func
};

export default Accordion;
